import {
  addWarehouseBag,
  fetchFillWarehouseBagFx,
  fillWarehouseBag,
} from '@/entities/warehouse/store';
import { IBag, IBagApi, IFillWarehouseBagData } from '../ts';
import { notification } from 'antd';
import { IWarehouseWithBags } from '@/modules/warehouses/ts';

export const copyBag = async ({
  bag,
  adressId,
  wh,
}: {
  bag: IBag;
  adressId: string;
  wh: IWarehouseWithBags | null;
}) => {
  try {
    // fillWarehouseBagSuccess();
    const params: any = {};
    bag.values.forEach((item: any) => {
      params[item.name] = String(item.value);
    });
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const hours = date.getHours();
    const minutes = date.getMinutes();

    console.log(bag);

    var formattedDate =
      year +
      '-' +
      (month < 10 ? '0' + month : month) +
      '-' +
      (day < 10 ? '0' + day : day) +
      ` ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    const data: IFillWarehouseBagData | any = {
      weight: bag.weight,
      //wheatType: Number(bag.values.find((item) => item.name === 'Тип')?.value),
      filling_date: formattedDate,
      parameters: params,
      agriculture_id: bag.agricultureId,
      warehouse_id: bag.warehouseId,
      description: bag.description,
      // nochange: false,
    };
    const res = await fetchFillWarehouseBagFx({
      bagId: adressId,
      data: data as IFillWarehouseBagData,
    });
    // if (adressId === wh?.bags[wh?.bags.length - 1].id) addWarehouseBag(Number(wh?.id));
    return notification.success({
      message: wh?.type === 1 ? 'Объём успешно скопирован' : 'Рукав успешно скопирован',
    });
  } catch (err) {
    console.log(err, ' - err');
    // в эффекте прописана обработка ошибки, поэтому убираем отображение ошибки тут
    //   notification.warning({
    //     message:
    //       'При копировании рукава что-то пошло не так. Попробуйте, пожалуйста, позже',
    //   });
  }
};
